<template>
  <transition name="overlay-fade">
    <div class="overlay" v-if="innactive">
      <div class="overlay-content reset-content">
        <div class="message">{{ t("is_there_anybody_here") }}</div>
        <div class="buttons-container">
          <div class="btn btn--primary" @click="$emit('change', false)">
            {{ t("continue_previous_session") }}
          </div>
          <span @click="$emit('change', false)">
            <router-link class="btn btn--primary" :to="{ name: 'home', params: { lang: $route.params.defaultLang } }"
              event="click">{{ t("reset_session") }}</router-link>
          </span>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ["innactive"],
  model: {
    prop: "innactive",
    event: "change",
  },
};
</script>
<style lang="stylus">
.overlay
  background-color: rgba(255, 255, 255, 0.95)
  height: 100%
  left: 0
  position: fixed
  top: 0
  width: 100%
  z-index: 999

  &.overlay-fade-enter-active,
  &.overlay-fade-leave-active
    transition: opacity 0.8s

  &.overlay-fade-enter,
  &.overlay-fade-leave-to /* .overlay-fade-leave-active below version 2.1.8 */
    opacity: 0

  .overlay-content
    left: 50%
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)
    z-index: 6

    &.reset-content
      margin-top: vw(-50px)

      .message
        m-font-size(50, 60)
        font-weight: 600
        margin-bottom: vw(100px)
        text-align: center

      .buttons-container
        align-items: center
        display: flex
        gap: vw(40px)

      .btn
        m-font-size(28, 40)
        height: vw(150px)
        padding: 0
        width: vw(400px)
</style>